import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Trophy, Shield, Shirt, ArrowRight, MapPin } from "lucide-react";

// One-time announcement for logged-in players. Bump the version to re-show.
export const WHATS_NEW_VERSION = "ci_jersey_v1";

const Item = ({ icon: Icon, title, children }) => (
  <div className="flex items-start gap-3">
    <div className="shrink-0 w-9 h-9 rounded-lg bg-[#C41E24]/15 flex items-center justify-center"><Icon size={18} className="text-[#C41E24]" /></div>
    <div>
      <div className="font-subheadings font-bold uppercase tracking-wide text-sm text-white">{title}</div>
      <div className="text-xs text-white/55 mt-0.5 leading-relaxed">{children}</div>
    </div>
  </div>
);

export default function WhatsNewModal({ open, onClose, onUpdateProfile }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="whats-new-modal"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.92, opacity: 0, y: 20 }} animate={{ scale: 1, opacity: 1, y: 0 }} exit={{ scale: 0.95, opacity: 0 }}
            transition={{ type: "spring", damping: 22, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md bg-[#111] border border-[#C41E24]/40 rounded-2xl overflow-hidden shadow-[0_30px_90px_rgba(0,0,0,0.7)]"
          >
            <button data-testid="whats-new-close" onClick={onClose} aria-label="Close"
              className="absolute top-3.5 right-3.5 text-white/40 hover:text-white transition-colors z-10"><X size={20} /></button>

            <div className="relative px-6 pt-7 pb-5 bg-gradient-to-br from-[#C41E24]/30 via-[#1a0708] to-transparent">
              <div className="absolute -top-8 -right-6 w-32 h-32 rounded-full bg-[#C41E24]/25 blur-2xl" />
              <div className="relative text-[10px] uppercase tracking-[0.3em] text-[#F5C518] font-bold mb-1">What's New 🎉</div>
              <h2 className="relative font-headings text-2xl uppercase tracking-wide leading-tight">The Central Illinois Season Is On</h2>
            </div>

            <div className="px-6 py-5 space-y-4">
              <Item icon={MapPin} title="Central Illinois Leaderboard">See how you rank against players right in your area — it's your new default board.</Item>
              <Item icon={Shield} title="Club & School Rivalry">Reppin' your club and school now stacks points on the Top Clubs & Top Schools boards.</Item>
              <Item icon={Shirt} title="Win a Free Training Jersey">Finish #1 by <span className="text-white font-semibold">Sept 30th</span> and score a free Next O Training Jersey.</Item>
            </div>

            <div className="px-6 pb-6 pt-1 space-y-2.5">
              <button data-testid="whats-new-update-profile" onClick={onUpdateProfile}
                className="w-full flex items-center justify-center gap-2 bg-[#C41E24] hover:bg-[#A0161D] text-white font-subheadings font-bold uppercase tracking-wider text-sm py-3.5 rounded-lg transition-colors">
                <Trophy size={16} /> Add My School &amp; Club <ArrowRight size={15} />
              </button>
              <button data-testid="whats-new-later" onClick={onClose}
                className="w-full text-center text-xs font-bold uppercase tracking-wider text-white/40 hover:text-white transition-colors py-1">
                Maybe later
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
